import { useState } from 'react'
import { getAtendimentoByProtocolo, isAceiteTermoPendente, loginByToken } from '../core/_requests'
import { useParams, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import {
  ButtonType,
  IconPaths,
  IconSize,
  KTSVG,
  MaskType,
  showAlert,
  showError,
} from '../../../../_metronic/helpers'
import { Button, ContactSupportLink, FormInput, LoadingIndicator } from '../../../components'
import { TokenDtoAtendimento } from '../core/_models'
import { setTeleAuth } from '../core/teleConsultaAuth'
import { loginSchema } from './validation/loginSchema'
import styles from './styles/LoginTeleConsulta.module.css'

export const LoginTeleConsulta = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { protocolo } = useParams()
  const navigate = useNavigate()

  const formik = useFormik({
    initialValues: {
      numeroDocumento: '',
    },
    validationSchema: loginSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setIsLoading(true)
      if (protocolo) {
        try {
          const digits = values.numeroDocumento.replace(/\D/g, '')
          const token: TokenDtoAtendimento = {
            cpf: digits.length === 11 ? values.numeroDocumento : undefined,
            cns: digits.length === 15 ? values.numeroDocumento : undefined,
            protocolo,
          }
          const data = await loginByToken(token)
          if (!data?.accessToken) {
            await showAlert({
              title: 'Erro!',
              text: 'Não foi possível validar seu acesso. Confira o documento informado e tente novamente.',
              icon: 'error',
            })
            return
          }
          setTeleAuth(data)

          // Identificar-se não registra aceite: quem já aceitou entra direto; quem não aceitou
          // recebe 403 ACEITE_TERMO_PENDENTE e vai para a etapa 2 (consentimento).
          try {
            await getAtendimentoByProtocolo(protocolo)
            navigate(`/tele-consulta/${protocolo}/atendimento`)
          } catch (error) {
            if (isAceiteTermoPendente(error)) {
              navigate(`/tele-consulta/${protocolo}/consentimento`)
            } else {
              throw error
            }
          }
        } catch (error) {
          showError(error)
        } finally {
          setIsLoading(false)
          setSubmitting(false)
        }
      }
    },
  })

  return (
    <div className='container d-flex flex-column justify-content-center align-items-center flex-grow-1'>
      <div
        className='d-flex flex-column bg-gray-200 rounded-4 w-100 p-4 p-md-5'
        style={{ maxWidth: '480px' }}
      >
        <div className={styles.badgeWrap} aria-hidden='true'>
          <span className={styles.ring} />
          <span className={styles.badge}>
            <KTSVG path={IconPaths.Estetoscopio} size={IconSize.Medium} />
          </span>
        </div>

        <div className='text-center mb-8'>
          <p className={`${styles.etapa} text-primary fw-bold fs-7 mb-2`}>
            Etapa 1 de 2 — Identificação
          </p>
          <h1 className='text-dark mb-2 fs-2x'>Iniciar Teleconsulta</h1>
          <p className='text-gray-700 fs-6 mb-0'>
            Confirme sua identidade para entrar na sala de atendimento
          </p>
        </div>

        <form onSubmit={formik.handleSubmit}>
          <FormInput
            formik={formik}
            label='CPF ou CNS'
            name='numeroDocumento'
            placeholder='Digite seu CPF ou CNS'
            mask={MaskType.CpfCns}
            className='mb-6'
            isRequired
          />
          <Button
            type={ButtonType.Submit}
            className='btn-primary btn-auth-full mt-6'
            disabled={isLoading || formik.isSubmitting}
            icon={isLoading ? undefined : IconPaths.Estetoscopio}
            iconSize={IconSize.Small}
          >
            {isLoading ? <LoadingIndicator /> : 'Continuar'}
          </Button>

          <p className='text-center text-gray-700 fs-8 mt-6 mb-0 d-flex flex-center'>
            <svg
              className='me-2'
              width='14'
              height='14'
              viewBox='0 0 16 16'
              fill='currentColor'
              aria-hidden='true'
            >
              <path d='M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.8 11.8 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7 7 0 0 0 1.048-.625 11.8 11.8 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.54 1.54 0 0 0-1.044-1.263 63 63 0 0 0-2.887-.87C9.843.266 8.69 0 8 0m0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5' />
            </svg>
            Ambiente seguro. Seus dados são tratados conforme a LGPD.
          </p>

          <div className='text-center mt-4'>
            <ContactSupportLink message='Problemas para iniciar? Fale com o suporte.' />
          </div>
        </form>
      </div>
    </div>
  )
}
